export const NIELSEN_LEGACY_VALUE = 'Nielsen';
export const NIELSEN_DTA_P2_PLUS_VALUE = 'Nielsen DTA P2+';

const normalizeForComparison = (value: string): string => value.trim().toUpperCase();

const NIELSEN_LEGACY_VALUE_NORMALIZED = normalizeForComparison(NIELSEN_LEGACY_VALUE);
const NIELSEN_DTA_P2_PLUS_VALUE_NORMALIZED = normalizeForComparison(NIELSEN_DTA_P2_PLUS_VALUE);

export const isNielsenLegacyValue = (rawValue: string | null | undefined): boolean =>
  !!rawValue && normalizeForComparison(rawValue) === NIELSEN_LEGACY_VALUE_NORMALIZED;

export const isNielsenDtaP2PlusValue = (rawValue: string | null | undefined): boolean =>
  !!rawValue && normalizeForComparison(rawValue) === NIELSEN_DTA_P2_PLUS_VALUE_NORMALIZED;

export const isNielsenFamilyValue = (rawValue: string | null | undefined): boolean =>
  isNielsenLegacyValue(rawValue) || isNielsenDtaP2PlusValue(rawValue);

/**
 * Collapses any Nielsen-family raw value (legacy or new, any casing) to the literal currently
 * offered by the Billable Ad Server dropdown, per the `nielsen-dta-p2-plus-enabled` flag state.
 * Non-Nielsen values (e.g. '1P'/'3P') and empty/nullish values pass through unchanged.
 */
export const resolveNielsenBillableAdServerValue = (
  rawValue: string | null | undefined,
  isNielsenDtaP2PlusEnabled: boolean
): string | null | undefined => {
  if (!isNielsenFamilyValue(rawValue)) {
    return rawValue;
  }

  return isNielsenDtaP2PlusEnabled ? NIELSEN_DTA_P2_PLUS_VALUE : NIELSEN_LEGACY_VALUE;
};
